import { zipRecordPermissions } from './recordPermissions'
import type { FgaComputedRelation } from './generated/model'

/**
 * What a caller may do to one bill: every computed relation the model defines on `bill`, paired with
 * the camelCase key it is reported under. Wider than the vocabulary a permission set configures,
 * because seeing the record is computed from holding any permission rather than granted.
 */
export const BILL_RECORD_PERMISSIONS = [
  ['canView', 'can_view'],
  ['canEditBeforeAccept', 'can_edit_before_accept'],
  ['canAccept', 'can_accept'],
  ['canAssign', 'can_assign'],
  ['canApprove', 'can_approve'],
] as const satisfies readonly (readonly [string, FgaComputedRelation<'bill'>])[]

export type BillRecordPermissionKey = (typeof BILL_RECORD_PERMISSIONS)[number][0]

export type BillRecordPermissions = Record<BillRecordPermissionKey, boolean>

/** The answer for a caller with no access, and the seed every result is built from. */
export const NO_BILL_RECORD_PERMISSIONS: BillRecordPermissions = {
  canView: false,
  canEditBeforeAccept: false,
  canAccept: false,
  canAssign: false,
  canApprove: false,
}

export const toBillRecordPermissions = (allowed: readonly boolean[]): BillRecordPermissions =>
  zipRecordPermissions('bill', BILL_RECORD_PERMISSIONS, NO_BILL_RECORD_PERMISSIONS, allowed)
